import { render, staticRenderFns } from "./icons-preview.vue?vue&type=template&id=4a6bf977&"
import script from "./icons-preview.vue?vue&type=script&lang=js&"
export * from "./icons-preview.vue?vue&type=script&lang=js&"
import style0 from "./icons-preview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./icons-preview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports